// Core
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { Link, useHistory } from 'react-router-dom';
import { FaTelegramPlane } from 'react-icons/fa';
import { useQuery } from 'react-query';
import { SiCrystal } from 'react-icons/si';
import { IoIosClose } from 'react-icons/io';
import { IoCloseOutline } from 'react-icons/io5';
import { FaHeart } from 'react-icons/fa';

// Assets
import { apiService } from 'services/ApiService';
import { parseMessageDate, validateLoadMore } from 'services/Utils';
import placeholderUser from 'assets/img/placeholder-user.png';
import { textLang } from 'services/Lang';

// Components
import LikedModal from './Modal';
import ErrorCard from 'components/Form/Errors';
import CountdownTimer from 'components/Countdown';
import MatchInfo from '../MatchPeople/components/MatchInfo';
import BalanceModal from '../MatchPeople/components/modals/Balance';

const LikedMe = (props) => {
	const [showInfo, setShowInfo] = useState();
    const [people, setPeople] = useState([]);
    const [metaPeople, setMetaPeople] = useState([]);
    const limit = 25;
    const [offset, setOffset] = useState(0);
    const [isError, setIsError] = useState();

    const { refetch, isFetching, isLoading } = useQuery({
	    queryKey: ['data-liked-me', offset],
	    queryFn: async () => {
	      const params = {
	        offset,
	        limit
	      };

	      const response = await apiService.getLikedMe(params);

          if(offset === 0){
            setPeople(response.data);
          } else {
            setPeople([...people, ...response.data]);
          }
          setMetaPeople(response.meta);
	      
	      return true;
	    },
	    refetchOnWindowFocus: false,
	    retry: false,
  	});

  	const loadMore = async () => {
        setOffset(offset + limit);
    };

  	const { refetch: showLikedMeStatusRefetch, data: showLikedMeStatusData, isLoading: showLikedMeStatusIsLoading } = useQuery({
	    queryKey: ['data-liked-me-show-status'],
	    queryFn: async () => {
	      const response = await apiService.showLikedMeStatus();
	      return response.data;
	    },
	    refetchOnWindowFocus: false,
	    retry: false,
  	});

  	const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  	const { isOpen, onClose, onOpen } = useDisclosure();
  	const handlePay = async () => {
  		setIsError();
  		setIsLoadingBtn(true);

	    try {
		  	const response = await apiService.showLikedMe();	
		  	if(response.statusCode === 404){
		  		setIsError(response.message);
		  		onClose();
		  		setIsLoadingBtn(false);
		  		return;
		  	}

		  	setTimeout(() => {
		    	showLikedMeStatusRefetch();
		  	}, 3500);

		    setTimeout(() => {
		    	onClose();
		    	setIsLoadingBtn(false);
		  	}, 5000);
	    } catch(e){
	    	setIsError(e);
	    	setIsLoadingBtn(false);
	    }
	};

	const [hideIds, setHideIds] = useState([]);
	const setDisLike = useCallback(async (objectId) => {
	  try {
	    await apiService.dislike({ id: objectId });
	    setHideIds((prev) => [...prev, objectId]);
	  } catch (e) {}
	  return true;
	}, []);

	const setLike = useCallback(async (objectId) => {
	    try {
	      const response = await apiService.like({id: objectId});
	      if(response.statusCode === 200){
	        setHideIds((prev) => [...prev, objectId]);
	      } else {
	        onOpenBalance();
	      }
	    } catch (e){
	      onOpenBalance();
	    }

	    return true;
	});

	const history = useHistory();
	const { isOpen: isOpenBalance, onClose: onCloseBalance, onOpen: onOpenBalance } = useDisclosure();
	const handleBalance = async () => {
	      onCloseBalance();
	      history.push('/profile/balance');  
	};

	return (
		<Box>
			<Flex w="100%" gap="16px" alignItems="center" justifyContent="space-between" pb="16px">
				<Text variant="title-lg" 
		          fontWeight="800"
		          textTransform="uppercase"
		          fontSize="32px">{textLang('liked_me')}</Text>

		        { !showLikedMeStatusIsLoading && 
		        	<Box>
		        		{new Date(showLikedMeStatusData) < new Date() ?
					        <Button variant="solid-lg"
					        	w="190px !important"
					        	onClick={onOpen}
					        	rightIcon={<SiCrystal fontSize="24px" />}>{textLang('open_for')} 1000</Button>
					       	: 
					       	<Box
					       		bg="#ff4133"
							    padding="6px 24px"
							    borderRadius="8px"
							    borderRadius="full"
							    color="white"
							    fontWeight="600"
					       		textAlign="center">
					       		<Text fontSize="14px" color="white">{textLang('likes_unlocked')} ⏰</Text>
					       		<CountdownTimer targetDate={showLikedMeStatusData} />
					       	</Box>
				       }
			       	</Box>
			    }
		    </Flex>

		    { isError && <ErrorCard error={isError} mt="0px" /> }

		    <LikedModal
			  handle={handlePay}
			  isOpen={isOpen}
			  onClose={onClose}
			  userData={props.object}
			  isLoadingBtn={isLoadingBtn}
			/>

			<BalanceModal
		      handle={handleBalance}
		      isOpen={isOpenBalance}
		      onClose={onCloseBalance}
		    />

			{ new Date(showLikedMeStatusData) > new Date() &&
				<Box className="match-user-info" h={ showInfo ? '80%' : '0' }>
			          <Box onClick={() => setShowInfo()} top="20px" right="10px" position="absolute">
			            <IoIosClose fontSize="70px" />
			          </Box>
			          <MatchInfo item={showInfo} />
			    </Box>
		    }

            <Grid mt="16px" alignItems="top" templateColumns={{ base: '1fr 1fr', md: '1fr 1fr 1fr 1fr 1fr' }} gap="16px" templateRows='1fr' zIndex="2">
	        	{ people?.length > 0 && people?.map((item, index) => (
		            <Box key={index} 
		            	position="relative"
		            	h="200px"
		            	opacity={hideIds.includes(item?.id) ? 0.2 : 1}
		            	pointerEvents={hideIds.includes(item?.id) ? 'none' : 'unset'}
		            	_before={{
		            		content: '""',
		            		position: 'absolute',
		            		w: '100%',
		            		h: '100%',
		            		bg: '#ffffffad',
		    						backdropFilter: 'blur(3px)',
		    						borderRadius: '16px',
		    						display: item?.id ? 'none' : 'block'
		            	}}>
		            	<Box w="100%" h="100%" position="relative">
		            		<Image 
		            			zIndex="2"
		            			borderRadius="16px"
		            			src={item?.image || placeholderUser} 
		            			w="100%" h="100%"
		            			onClick={() => setShowInfo(item)} 
		            			objectFit="cover" 
		            			position="relative"
		            			/>

		            		{ new Date(showLikedMeStatusData) > new Date() ?
			            		<Flex 
			            			position="absolute" 
			            			justifyContent="space-around"
			            			bottom="0"
			            			backdropFilter="blur(3px)"
										    w="100%"
										    p="6px 0"
										    borderRadius="0 0 16px 16px"
			            			zIndex="2">

			            			<IoCloseOutline 
			            				color="#535353"
			            				onClick={() => { 
							              setDisLike(item?.id);
							            }} 
			            				fontSize="32px" />

			            			<FaHeart 
			            				color="rgb(255, 65, 51)" 
			            				onClick={() => { 
							              setLike(item?.id);
							            }} 
			            				fontSize="32px" />

			            		</Flex>
			            	 : 
			            	 <Box 
			            	 	position="absolute" 
			            	 	bg='#ffffffad'
		    							backdropFilter='blur(4px)'
		    							zIndex="9"
		    							borderRadius='16px'
		    							border="1px solid #d5d5d5"
			            	 	w="100%" h="100%" left="0" top="0" />
			            	}
	            		</Box>
            		</Box>
		        ))}

		        { !isFetching && people?.length === 0 && <Text>{textLang('likes_locked_text')}</Text>}
	        </Grid>

	        { validateLoadMore(people, metaPeople) && (
                <Button 
                    isLoading={isLoading} 
                    variant="solid-lg" 
                    maxW="220px" 
                    onClick={loadMore} 
                    left="50%"
                    transform="translate(-50%, 0)"
                    m="24px auto">
                  Load More
                </Button>
            )}

		</Box>
	);
};

export default LikedMe;